import React from 'react';
import PageError from '../pages/page-error';

const AccountDisabled = () => (
  <PageError errorCode={404} />
);

export default AccountDisabled;
